<h2 mat-dialog-title class="dialog-title" *ngIf="selectedContact">
  <ng-container>
    <pezi-button text="Zurück zur Suche" (click)="removeSelection()" [isAccentSecondary]="true" icon="arrow_back"></pezi-button>
  </ng-container>
</h2>
<mat-dialog-content class="dialog-content search-dialog">
  <div [ngClass]="{'nonVisible' : selectedContact}">
    <app-contact-search [disableDialog]="true"
                        (onContactSelected)="selectContact($event)"
                        (onOverviewButtonClicked)="closeDialog()"></app-contact-search>
  </div>
  <app-contact-detail [currentContact]="selectedContact ? selectedContact.data : null"></app-contact-detail>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <pezi-button text="Schließen" [isPlain]="true" icon="close" [alignIconRight]="true" mat-dialog-close></pezi-button>
</mat-dialog-actions>



